import { render, staticRenderFns } from "./DynamicPhone.vue?vue&type=template&id=2469974e&lang=pug&"
import script from "./DynamicPhone.vue?vue&type=script&lang=js&"
export * from "./DynamicPhone.vue?vue&type=script&lang=js&"
import style0 from "./DynamicPhone.vue?vue&type=style&index=0&id=2469974e&prod&lang=sass&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports